import { render } from "./CompletedTrainingsView.vue?vue&type=template&id=5f3251f2"
import script from "./CompletedTrainingsView.vue?vue&type=script&lang=js"
export * from "./CompletedTrainingsView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__